import React from 'react'
import FormDialog, {FormDialogTypes, FormInputProps,} from '@yaak/components/src/FormDialog/FormDialog'
import {FeatureFlagAdmin} from '@yaak/components/services/api/api'
import FlagIcon from '@mui/icons-material/Flag';


interface FeatureFlagEditProps {
  token: string
  selectedFeatureFlag: FeatureFlagAdmin | null
  onCancel: () => void
  onConfirmed: (result: any) => Promise<any>
}

export const nameDialogInput = {
  name: 'name',
  title: 'Name (this value cannot be changed once created. Must be camelCase.)',
  required: true,
  placeHolderText: '',
  validate: (name: string) => name.length >= 2 && /^[a-z][a-zA-Z0-9]*$/.test(name),
}

export const descriptionDialogInput = {
  name: 'description',
  title: 'Description',
  required: true,
  placeHolderText: '',
  validate: (name: string) => name.length >= 2,
}


export const enabledDialogInput = {
  name: 'enabled',
  title: 'Enabled',
  value: false,
}

const buildDialogInputs = async (
  selectedFlag: FeatureFlagAdmin | null,
): Promise<FormInputProps[]> => {
  if (selectedFlag === null) {
    return []
  }

  const dialogInputs = [
    {
      ...descriptionDialogInput,
      value: selectedFlag.description,
    },
    {
      ...enabledDialogInput,
      value: selectedFlag.enabled,
    },
  ]

  return dialogInputs
}

const FeatureFlagEditDialog: React.FunctionComponent<FeatureFlagEditProps> = ({
  token,
  selectedFeatureFlag,
  onCancel,
  onConfirmed,
}) => {
  return (
    <FormDialog
      titleIcon={<FlagIcon />}
      title={`Edit feature flag: ${selectedFeatureFlag?.name}`}
      dialogType={FormDialogTypes.edit}
      inputs={() =>
        buildDialogInputs(
          selectedFeatureFlag
        )
      }
      open={selectedFeatureFlag !== null}
      confirmationTitle={''}
      onCancel={onCancel}
      onConfirmed={onConfirmed}
    ></FormDialog>
  )
}

export default FeatureFlagEditDialog
